import * as request from '@/utils/request'
const BASE_URL = '/v1/manage'
export default {
  // 套餐充值 -  运营商列表
  getPackageOperatorManageList(data) {
    return request.post(`/v1/hr/recharge/operatorList`, data)
  },
  // 套餐充值 - 公司列表
  getPackageOperatorCompanyList(data) {
    return request.post(`/v1/hr/recharge/operatorCompanyList`, data)
  },
  getSupplierList(data) {
    return request.get(`${BASE_URL}/supplier`,data)
  },
  getSupplierCustomerList(data) {
    return request.get(`${BASE_URL}/supplier/customer/index`,data)
  },
  // 解绑客户
  deleteSupplierCustomerInfo(data) {
    return request.post(`${BASE_URL}/supplier/customer/delete/bind`,data)
  },
  // 新增
  createSupplier(data) {
    return request.post(`${BASE_URL}/supplier`,data)
  },
  // 编辑
  editSupplier(id,data) {
    return request.put(`${BASE_URL}/supplier/${id}`,data)
  },
  // 获取运行商详情
  getSupplierInfo(id) {
    return request.get(`${BASE_URL}/supplier/${id}`)
  },
  // 取消资格
  deleteSupplierInfo(id) {
    return request.Delete(`${BASE_URL}/supplier/${id}`)
  },
  // 套餐余量
  getSurPlusNum(data){
    return request.post(`/v1/hr/recharge/setMealView`,data)
  },
}
